import { BETA_URL } from "app/api/config"
import { getAccessToken } from "app/localStorage/token"
import { parseToken } from "utils/utils"

// Thomas switches a user to the beta in Auth0 (app_metadata.beta); the post-login Action puts it in the token.
export const BETA_CLAIM = "https://ppt/beta"
// "Terug naar het oude Docket" opens the old app with ?stay=1: no redirect to the beta for the rest of that tab.
export const STAY_KEY = "docket_stay_old_app"

export function isSwitchedToBeta(accessToken: string | null, now = Date.now()): boolean {
  try {
    const claims = parseToken(accessToken!)
    return claims?.[BETA_CLAIM] === true && claims.exp * 1000 > now
  } catch {
    return false
  }
}

export function rememberStay(search: string): void {
  if (new URLSearchParams(search).get("stay") === "1") sessionStorage.setItem(STAY_KEY, "1")
}

export const isStaying = (): boolean => sessionStorage.getItem(STAY_KEY) === "1"

export const shouldOpenBeta = (accessToken: string | null, staying: boolean): boolean =>
  !staying && isSwitchedToBeta(accessToken)

// The old app's side of the switch: at startup and right after login
export function redirectOldAppIfSwitched(betaUrl = BETA_URL): void {
  if (betaUrl && shouldOpenBeta(getAccessToken(), isStaying())) location.replace(betaUrl)
}
